import { render } from "./NoticeAdmin.vue?vue&type=template&id=2b1f29c9&scoped=true"
import script from "./NoticeAdmin.vue?vue&type=script&lang=js"
export * from "./NoticeAdmin.vue?vue&type=script&lang=js"

import "./NoticeAdmin.vue?vue&type=style&index=0&id=2b1f29c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1f29c9"]])

export default __exports__